module.exports = __webpack_public_path__ + "img/logo_white.813fe0d7.png";